<template>
  <v-container style="max-width: 480px; padding-top: 4rem">
    <v-card color="surface" class="pa-8">
      <div class="text-center mb-6">
        <v-icon color="primary" size="48" class="mb-2">mdi-lock-reset</v-icon>
        <h1 class="text-h5 font-weight-bold">Glemt adgangskode</h1>
        <p class="text-body-2 text-grey">
          Indtast din email, så sender vi et link til at nulstille din adgangskode.
        </p>
      </div>

      <v-form v-if="!sent" @submit.prevent="handleSubmit">
        <v-text-field
          v-model="email"
          label="Email"
          type="email"
          prepend-inner-icon="mdi-email-outline"
          :rules="[(v) => !!v || 'Email er påkrævet']"
          class="mb-4"
        />
        <v-btn type="submit" color="primary" size="large" block :loading="loading">
          Send nulstillingslink
        </v-btn>
      </v-form>

      <v-alert v-if="sent" type="success" variant="tonal">
        Hvis emailen findes i vores system, har vi sendt et nulstillingslink.
        Tjek din indbakke.
      </v-alert>

      <v-alert
        v-if="error"
        type="error"
        variant="tonal"
        class="mt-4"
        density="compact"
      >
        {{ error }}
      </v-alert>

      <p class="text-center text-body-2 mt-6 text-grey">
        <router-link to="/login" class="text-primary text-decoration-none">
          Tilbage til log ind
        </router-link>
      </p>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useAuthStore } from "../stores/auth";

const auth = useAuthStore();
const email = ref("");
const loading = ref(false);
const sent = ref(false);
const error = ref("");

async function handleSubmit() {
  error.value = "";
  loading.value = true;
  try {
    await auth.forgotPassword(email.value);
    sent.value = true;
  } catch (e) {
    error.value = e.response?.data?.error || "Noget gik galt";
  } finally {
    loading.value = false;
  }
}
</script>
